import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

require('@fancyapps/fancybox');
import {
    Swiper,
    Navigation,
    Pagination,
    Scrollbar,
    Controller,
    A11y,
    Grid,
    Autoplay
} from "swiper";
Swiper.use([Navigation, Pagination, Scrollbar, A11y, Controller, Grid, Autoplay]);

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

$(function () {

    const swiperGallery = new Swiper('.swiper--gallery', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper--gallery__controls .swiper-button--next',
            prevEl: '.swiper--gallery__controls .swiper-button--prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 'auto',
                centeredSlides: false,
                scrollbar: {
                    dragSize: 180,
                },
            },
        },
    });

    const swiperQuotes = new Swiper('.swiper--quotes', {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper--quotes__controls .swiper-button--next',
            prevEl: '.swiper--quotes__controls .swiper-button--prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                centeredSlides: false,
                scrollbar: {
                    dragSize: 180,
                },
            },
        },
    });

    const swiperClients = new Swiper('.swiper--clients', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button--client-next',
            prevEl: '.swiper-button--client-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 3,
                centeredSlides: false,
                scrollbar: {
                    dragSize: 180,
                },
            },
        },
    });

    const swiperMembers = new Swiper('.swiper--members', {
        slidesPerView: 'auto',
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 0,
        grid: {
            rows:2,
            fill: "row",
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
        navigation: {
            nextEl: '.swiper-button--member-next',
            prevEl: '.swiper-button--member-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                centeredSlides: false,
                scrollbar: {
                    dragSize: 180,
                },
            },
        },
    });

    megamenu.init();

    // animate scroll on a href^# links
    $("a[href^='#']").on('click', function (e) {
        var $this = $(this);
        const offset = Foundation.MediaQuery.atLeast('large') ? 99 : 71;
        if ($this.hasClass('accordion-title') || $this.parent().hasClass('tabs-title')) {
            return true;
        }
        e.preventDefault();
        $("html, body").animate({
            scrollTop: $($this.attr("href")).offset().top - offset
        }, 500);
    });

    function toggleWhiteTopbar() {
        $('.top-bar').toggleClass('top-bar--white');
    }

    $('#offCanvas').on('close.zf.offCanvas', function (event) {
        toggleWhiteTopbar();
    });
    $('#offCanvas').on('opened.zf.offCanvas', function (event) {
        toggleWhiteTopbar();
    });

    $(document).on('down.zf.accordionMenu', function(event, element) {
        $(element).parent().addClass('is-submenu-active');
    });
    $(document).on('up.zf.accordionMenu', function(event, element) {
        $(element).parent().removeClass('is-submenu-active');
    });

    var $number = $("#certificate_number");
    var $date = $("#certificate_date");
    var $submit = $("#certificate_submit");
    var $form = $("#verify_dimaq_certificate");
    var $result = $("#certificate_result");
    var g_recaptcha_response = '';

    $form.on("submit", function (event) {
        event.preventDefault();
        var number = $number.val();
        var date = $date.val();
        $submit.attr('disabled', true);
        $result.hide();

        g_recaptcha_response = grecaptcha.getResponse();

        $.ajax({
            'url': 'https://skuska.dimaq.sk/certificate/usercertificates/check',
            'method': 'POST',
            'data': {
                'number': number,
                'to_date': date,
                'g-recaptcha-response': g_recaptcha_response
            },
            success: function (xhr) {
                var response = JSON.parse(xhr);
                var result = response.result;
                $result.fadeIn(1000);

                if (result == false) {
                    $form.addClass('invalid');
                    $result.text('Certifikát nebol nájdený');
                } else if (result == true) {
                    var name = response.name;
                    $form.addClass('sent');
                    $result.text('Certifikát je vydaný na meno: ' + name);
                }

                //reset recaptcha
                window.grecaptcha.reset();
            }
        });
    });

    //--------------------
    //recaptcha callbacks
    //--------------------
    window.recaptcha_success_callback = function() {
        $submit.attr('disabled', false);
    };

    window.recaptcha_expire_callback = function() {
        $submit.attr('disabled', true);
    }
});

var megamenu = {
    init: function () {
        const topBar = $('.top-bar');

        $('.top-bar [data-dropdown]').on('show.zf.dropdown', function () {
            var $this = $(this);
            topBar.addClass('dropdown-opened');
            $this.find('.cell').css('transform', 'none');
        });
        $('.top-bar [data-dropdown]').on('hide.zf.dropdown', function () {
            var $this = $(this);
            //check if user is hovering over another dropdown
            if (!topBar.find('a.dropdown:hover').length) {
                topBar.removeClass('dropdown-opened');
            }
            $this.find('.cell').css('transform', '');
        });
    }
}